<template>
    <section v-if="hasSlot" class="data-container">
        <slot />
    </section>
</template>

<script>

import Item from './data-item'

export default {

    computed: {

        hasSlot() {
            return this.$slots.default ? true : false
        },
    },

    Item,
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_data-container.scss

.data-container {
    display: flex;
    flex-direction: column;
    min-height: 2.5rem;

    @include bp-min-mid {
        min-height: auto;
    }
}

</style>
